import { combineReducers, createReducer, on } from '@ngrx/store';
import { addAllPortfolios, decrementCurrentWizardStep, incrementCurrentWizardStep, resetAccountResultsLoaded, resetCurrentWizardStep, resetSelectAllPortfolios, resetSelectedPortfolios, selectGroup, selectPortfolio, setAccountResultsLoaded, setImportType, setPortfolioImportType, setSearchType, setSelectedPortfolioCustomSecurity, setSelectedPortfolios, toggleSelectAllPortfolios, viewPortfolioChildren, } from './import-holdings.actions';
import { ADDEPAR_GROUP } from 'IntegrationsApp/ts/constants';
import { CLIENT_PORTFOLIO } from 'ModelPortfolioApp/ts/shared/constants';
export const currentWizardStepIndex = createReducer(0, on(incrementCurrentWizardStep, (state) => {
    return state + 1;
}), on(viewPortfolioChildren, (state) => {
    return state + 1;
}), on(decrementCurrentWizardStep, (state) => {
    return state - 1;
}), on(resetCurrentWizardStep, () => {
    return 0;
}));
export const searchType = createReducer(ADDEPAR_GROUP, on(setSearchType, (state, { searchType: newSearchType }) => {
    return newSearchType;
}));
export const portfolioImportType = createReducer(CLIENT_PORTFOLIO, on(setPortfolioImportType, (state, { newPortfolioImportType }) => {
    return newPortfolioImportType;
}));
export const selectedGroup = createReducer(null, on(selectGroup, (state, { selectedGroup: newGroup }) => {
    return newGroup;
}));
export const selectedPortfolioHistory = createReducer([], on(viewPortfolioChildren, (state, { selectedPortfolio: newPortfolio }) => {
    return [newPortfolio, ...state];
}), on(resetCurrentWizardStep, () => {
    return [];
}), on(decrementCurrentWizardStep, (state) => {
    return state.slice(1);
}));
export const selectedPortfolios = createReducer([], on(selectPortfolio, (state, { selectedPortfolioId: newPortfolioId }) => {
    if (state.map((account) => account.id).includes(newPortfolioId)) {
        return state.filter((account) => account.id !== newPortfolioId);
    }
    return [...state, { id: newPortfolioId, importAsSingleHolding: false }];
}), on(setImportType, (state, { id, importAsSingleHolding }) => {
    if (state.map((account) => account.id).includes(id)) {
        return state.map((account) => {
            if (account.id === id) {
                return { ...account, importAsSingleHolding };
            }
            return account;
        });
    }
    return [...state, { id, importAsSingleHolding }];
}), on(resetSelectedPortfolios, () => {
    return [];
}), on(addAllPortfolios, setSelectedPortfolios, (state, { portfolios: serializedPortfolios }) => {
    return serializedPortfolios.map((portfolio) => {
        return { id: portfolio.id, importAsSingleHolding: false };
    });
}));
export const selectAllPortfolios = createReducer(false, on(toggleSelectAllPortfolios, (state) => {
    return !state;
}), on(resetSelectAllPortfolios, () => {
    return false;
}));
export const selectedPortfolioCustomSecurity = createReducer(null, on(setSelectedPortfolioCustomSecurity, (state, action) => {
    return { id: action.portfolio.id, importAsSingleHolding: false };
}), on(resetSelectedPortfolios, () => {
    return null;
}));
export const accountResultsLoaded = createReducer(false, on(setAccountResultsLoaded, (state, action) => {
    return action.loaded;
}), on(resetAccountResultsLoaded, () => {
    return false;
}));
export const addeparImportHoldings = combineReducers({
    currentWizardStepIndex,
    searchType,
    selectedGroup,
    selectedPortfolioHistory,
    selectedPortfolios,
    selectAllPortfolios,
    portfolioImportType,
    selectedPortfolioCustomSecurity,
    accountResultsLoaded,
});
